import React, { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import PageHeader from "../components/PageHeader";
import { FieldStyle } from "./PartiesPage";
import { Stack } from "@phosphor-icons/react";

export default function InventoryPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/inventory/stock");
    setRows(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="inventory-page">
      <PageHeader
        title="Inventory"
        subtitle="Current stock computed from opening stock plus Invoice / Challan / PO movements."
      />

      <div className="p-8">
        <div className="table-wrapper">
          <table className="table-base">
            <thead><tr>
              <th>Product</th>
              <th>HSN</th>
              <th>Unit</th>
              <th className="text-right">Opening Stock</th>
              <th className="text-right">Current Stock</th>
              <th></th>
            </tr></thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="text-center py-6 text-ink-muted">Loading…</td></tr>}
              {!loading && rows.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-ink-muted">No products yet. Add products in Masters → Products.</td></tr>}
              {rows.map(r => {
                const delta = (r.current_stock || 0) - (r.opening_stock || 0);
                const low = r.current_stock <= 0;
                return (
                  <tr key={r.id} data-testid={`inv-row-${r.id}`}>
                    <td className="font-semibold"><div className="flex items-center gap-2"><Stack size={14} className="text-ink-muted" />{r.name}</div></td>
                    <td className="font-mono text-xs">{r.hsn || "—"}</td>
                    <td>{r.unit}</td>
                    <td className="text-right tabular">{Number(r.opening_stock || 0).toFixed(3)}</td>
                    <td className={`text-right tabular font-semibold ${low ? "text-destructive" : "text-[#1C4F32]"}`}>{Number(r.current_stock || 0).toFixed(3)}</td>
                    <td>
                      {delta !== 0 && <span className={`status-pill ${delta > 0 ? "status-success" : "status-warning"}`}>{delta > 0 ? "+" : ""}{delta.toFixed(3)}</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <FieldStyle />
    </div>
  );
}
